module.exports = __webpack_public_path__ + "img/interface-03.c4d35a8a.jpg";